import React, { useState, useEffect } from 'react';
import elehomeLogo from './img/elehome.png'; // Import your elehome logo
import './Loader.css'; // Import your Loader styles

const Loader = () => {
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLoader(false);
    }, 1000); // Set the timer for 1 second

    return () => clearTimeout(timer);
  }, []);

  return (
    <div>
      {showLoader && (
        <div className="loader-backdrop">
          <div className="loader">
            <img src={elehomeLogo} alt="Loading..." />
          </div>
        </div>
      )}
    </div>
  );
};

export default Loader;
